const ENTITY_TITLE_CASE_RULES = [
  [/\bcampaigns\b/gi, 'Campaigns'],
  [/\bcampaign\b/gi, 'Campaign'],
  [/\binstitutional story\b/gi, 'Institutional Story'],
  [/\bissues\b/gi, 'Issues'],
  [/\bissue\b/gi, 'Issue'],
  [/\btactics\b/gi, 'Tactics'],
  [/\btactic\b/gi, 'Tactic'],
  [/\bmedia interactions\b/gi, 'Media Interactions'],
  [/\bmedia interaction\b/gi, 'Media Interaction'],
  [/\binteractions\b/gi, 'Interactions'],
  [/\binteraction\b/gi, 'Interaction'],
  [/\bengagements\b/gi, 'Engagements'],
  [/\bengagement\b/gi, 'Engagement'],
  [/\bservices\b/gi, 'Services'],
  [/\bservice\b/gi, 'Service'],
];

export const normalizeAnalyticsEntityTitleCase = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  return ENTITY_TITLE_CASE_RULES.reduce((acc, [pattern, replacement]) => acc.replace(pattern, replacement), value);
};
